import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'features/auth/authSelectors';
import { hasPermission, canAccessModule, hasAnyModulePermission } from 'utils/permissions';
import { ACTIONS } from 'constants/permissions';

/**
 * Permission hook for components.
 *   const { can, canView } = usePermissions();
 *   can(MODULES.STAGE1, ACTIONS.REJECT)
 */
export const usePermissions = () => {
  const user = useSelector(selectCurrentUser);
  return {
    user,
    can: (module, action = ACTIONS.VIEW) => hasPermission(user, module, action),
    canView: (module) => canAccessModule(user, module),
    canAnyIn: (module) => hasAnyModulePermission(user, module),
  };
};

export default usePermissions;
